export default class SukuColorRow extends HTMLElement {
  static get observedAttributes() {
    return ['type', 'active', 'selected', 'category', 'size']
  }

  constructor() {
    super()

    this.byline = 'Select Colour'

    this.className = 'flex flex-wrap'

    this.addEventListener('color', this.handleColor.bind(this))
    window.addEventListener('active', this.handleActive.bind(this))
  }

  connectedCallback() {
    this.type = this.getAttribute('type')
    this.active = this.getAttribute('active') === 'true' ? true : false
    this.selected = this.getAttribute('selected')
    this.category = this.getAttribute('category')
    this.size = this.getAttribute('size')
    this.byline = this.getAttribute('byline')


    const container = document.createElement('div')
    container.setAttribute('data-title-container', '')
    container.className = 'flex w-full text-base mb-6 mobile:text-sm'

    const title = document.createElement('p')
    title.setAttribute('data-title', '')
    title.className = 'font-base mb-0 font-semibold mobile:text-sm'
    
    const price = document.createElement('p')
    price.setAttribute('data-color-price', '')
    price.className = 'ml-10 mb-0 flex'

    title.textContent = this.byline
    container.appendChild(title)
    container.appendChild(price)
    this.appendChild(container)
    
    if (!this.active) {
      this.classList.add('hidden')
    }
  }

  handleColor(evt) {
    const selected = JSON.parse(document.querySelector('suku-controls').getAttribute('selected'))
    const textures = { main: evt.detail.texture, style: evt.detail.style, alt: evt.detail.alt }
    const color = evt.detail.color

    if (this.selected.includes(evt.detail.color)) {
      return
    }

    // this.colorName.textContent = name
    const buttons = this.querySelectorAll('suku-color-button')
    Array.from(buttons).forEach(button => {
      const active = color === button.getAttribute('color')

      button.setAttribute('active', active)
    })
    
    this.setAttribute('color', color)

    this.dispatchEvent(new CustomEvent('sceneupdate', { bubbles: true, detail: { selected: selected, textures: textures } }))
  }
  
  handleActive(evt) {
    const buttons = this.querySelectorAll('suku-color-button')

    if (evt.detail.relation !== this.type) {
      this.setAttribute('active', false)
      this.setAttribute('selected', '')
      // this.colorName.textContent = ''

      Array.from(buttons).forEach(button => {
        button.setAttribute('available', false)
        button.setAttribute('active', false)
      })

      return
    }

    const active = evt.detail.relation === this.type

    this.setAttribute('active', active)
    
    const selected = JSON.parse(document.querySelector('suku-controls').getAttribute('selected'))

    this.setAttribute('category', selected.category)
    this.setAttribute('size', selected.size)

    const colors = []
    window.__SUKU_Options.forEach(option => {
      if (selected.category === option.category && !colors.includes(option.color)) {
        colors.push(option.color)
      }
    })
    
    Array.from(buttons).forEach(button => {
      const available = colors.includes(button.getAttribute('name'))
      button.setAttribute('available', available)
    })
  }

  toggle() {
    if (this.active) {
      this.classList.remove('hidden')
    } else {
      this.classList.add('hidden')
    }
  }

  attributeChangedCallback(name, current, value) {
    if (current === value) {
      return
    }

    switch (name) {
      case 'type' :
        this.type = value
        break
      case 'active' :
        this.active = value === 'true' ? true : false

        this.toggle()
      break
      case 'selected' :
        this.selected = value
        break
      case 'category' :
        this.category = value
        break
      case 'size' :
        this.size = value
    }
  }
}

customElements.define('suku-color-row', SukuColorRow)


